"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const utils_1 = require("./utils");
const react_helmet_1 = require("react-helmet");
exports.ArticleMicrodata = ({ author, authorName, datePublished, headline, image, publisher, publisherLogo, description, dateModified, }) => {
    let finalJson = `{
    "@context": "https://schema.org",
      "@type": "NewsArticle",
      "headline": "${utils_1.addslashes(headline)}"
  `;
    if (author) {
        finalJson += `,"author": ${utils_1.getPersonJson(author)}`;
    }
    if (image) {
        finalJson += `,"image": [
      ${utils_1.toArray(image)
            .map(element => '"' + element + '"')
            .join(',')}
    ]   `;
    }
    if (authorName) {
        finalJson += `,"author.name": "${authorName}"`;
    }
    if (datePublished) {
        finalJson += `,"datePublished": "${datePublished}"`;
    }
    if (dateModified) {
        finalJson += `,"dateModified": "${dateModified}"`;
    }
    if (publisher) {
        finalJson += `,"publisher": ${utils_1.getOrganizationJson(publisher)}`;
    }
    finalJson += '}';
    return (React.createElement(react_helmet_1.Helmet, null,
        React.createElement("script", { type: "application/ld+json" }, finalJson)));
};
